import React, { useState } from 'react';
import { Modal, Notice, Icon } from './components';

export default function ExportDialog({ api, sessionId, view, count, sheets, onClose }) {
  const [format, setFormat] = useState(sheets.enabled ? 'sheets' : 'csv');
  const [spreadsheet, setSpreadsheet] = useState(sheets.defaultSpreadsheetId || '');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  const [result, setResult] = useState(null);
  async function exportList(event) {
    event.preventDefault(); setBusy(true); setError(''); setResult(null);
    try {
      const data = await api('/exports', { method: 'POST', body: { sessionId, view, format, spreadsheet }, download: format === 'csv' });
      if (format === 'csv') {
        const url = URL.createObjectURL(data);
        const link = document.createElement('a');
        link.href = url; link.download = 'etudiants-echange.csv'; document.body.appendChild(link); link.click(); link.remove();
        setTimeout(() => URL.revokeObjectURL(url), 1000);
        setResult({ csv: true });
      } else setResult(data);
    } catch (e) { setError(e.message); }
    finally { setBusy(false); }
  }
  return <Modal title="Exporter la liste" onClose={onClose} busy={busy}>
    <p className="ex-muted">{count} étudiant(s), avec les colonnes, les filtres et l’ordre de tri de la vue actuelle. L’export inclut toutes les pages de la liste.</p>
    <Notice>{error}</Notice>
    <form className="ex-form" onSubmit={exportList}><label>Format<select value={format} disabled={busy} onChange={event => { setFormat(event.target.value); setResult(null); }}><option value="csv">Fichier CSV</option><option value="sheets" disabled={!sheets.enabled}>Google Sheets{!sheets.enabled ? ' — à configurer' : ''}</option></select></label>
      {format === 'sheets' && <><label>Classeur de destination<input required value={spreadsheet} disabled={busy} onChange={event => { setSpreadsheet(event.target.value); setResult(null); }} placeholder="https://docs.google.com/spreadsheets/d/…" /></label><p className="ex-help">Partagez le classeur en modification avec <strong>{sheets.email}</strong>. L’export ajoutera un nouvel onglet daté.</p></>}
      {result && <Notice type="success">{result.csv ? 'Le fichier CSV a été téléchargé.' : <>L’export est prêt. <a href={result.url} target="_blank" rel="noopener noreferrer">Ouvrir le nouvel onglet Google Sheets ↗</a></>}</Notice>}
      <div className="ex-modal-footer"><button className="ex-button" type="button" onClick={onClose} disabled={busy}>Fermer</button><button className="ex-button ex-button--primary" disabled={busy || !count}><Icon name="download" size={17} />{busy ? 'Export en cours…' : 'Exporter'}</button></div>
    </form>
  </Modal>;
}
